<template>
  <InstallPWAMobileView
    :key="viewkey"
    v-if="step == 0 && os == 'android'"
    :main-header="t$('.android.install.header')"
    :hint="t$('.android.install.hint')"
    :step1="AndroidStep1"
    :step2="AndroidStep2"
    :step3="AndroidStep3"
    :forwards-button-text="t$('.android.install.forwards_button')"
    @forwards="navigateForwards"
  />
  <InstallPWAMobileView
    :key="viewkey"
    v-else-if="step == 1 && os == 'android'"
    :main-header="t$('.android.activate.header')"
    :hint="t$('.android.activate.hint')"
    :step1="AndroidStep4"
    :step2="AndroidStep5"
    :step3="AndroidStep6"
    :forwards-button-text="t$('.android.activate.forwards_button')"
    :backwards-button-text="t$('.android.activate.backwards_button')"
    @forwards="$emit('close')"
    @backwards="navigateBackwards"
  />
  <InstallPWAMobileView
    :key="viewkey"
    v-else-if="step == 0 && os == 'ios'"
    :main-header="t$('.ios.install.header')"
    :hint="t$('.ios.install.hint')"
    :step1="IOSStep1"
    :step2="IOSStep2"
    :step3="IOSStep3"
    :forwards-button-text="t$('.ios.install.forwards_button')"
    @forwards="navigateForwards"
  />
  <InstallPWAMobileView
    :key="viewkey"
    v-else-if="step == 1 && os == 'ios'"
    :main-header="t$('.ios.activate.header')"
    :hint="t$('.ios.activate.hint')"
    :step1="IOSStep4"
    :step2="IOSStep5"
    :step3="IOSStep6"
    :forwards-button-text="t$('.ios.activate.forwards_button')"
    :backwards-button-text="t$('.ios.activate.backwards_button')"
    @forwards="$emit('close')"
    @backwards="navigateBackwards"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import Button from "components/UI/Button.vue"
import Subtitle from "components/UI/Subtitle.vue"
import TextBody from "components/UI/TextBody.vue"
import InstallPWAMobileView from "features/push/InstallPWAMobileView.vue"

export type OSType = "ios" | "android"

import AndroidStep1 from "./assets/install-screens/AndroidStep1.png"
import AndroidStep2 from "./assets/install-screens/AndroidStep2.png"
import AndroidStep3 from "./assets/install-screens/AndroidStep3.png"
import AndroidStep4 from "./assets/install-screens/AndroidStep4.png"
import AndroidStep5 from "./assets/install-screens/AndroidStep5.png"
import AndroidStep6 from "./assets/install-screens/AndroidStep6.png"

import IOSStep1 from "./assets/install-screens/IOSStep1.png"
import IOSStep2 from "./assets/install-screens/IOSStep2.png"
import IOSStep3 from "./assets/install-screens/IOSStep3.png"
import IOSStep4 from "./assets/install-screens/IOSStep4.png"
import IOSStep5 from "./assets/install-screens/IOSStep5.png"
import IOSStep6 from "./assets/install-screens/IOSStep6.png"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "InstallPWAMobileWizard",
  components: { InstallPWAMobileView, TextBody, Subtitle, Button },
  props: {
    os: {
      type: String as PropType<OSType>,
      required: true,
    },
  },
  computed: {
    AndroidStep1() {
      return AndroidStep1
    },
    AndroidStep2() {
      return AndroidStep2
    },
    AndroidStep3() {
      return AndroidStep3
    },
    AndroidStep4() {
      return AndroidStep4
    },
    AndroidStep5() {
      return AndroidStep5
    },
    AndroidStep6() {
      return AndroidStep6
    },
    IOSStep1() {
      return IOSStep1
    },
    IOSStep2() {
      return IOSStep2
    },
    IOSStep3() {
      return IOSStep3
    },
    IOSStep4() {
      return IOSStep4
    },
    IOSStep5() {
      return IOSStep5
    },
    IOSStep6() {
      return IOSStep6
    },
  },
  methods: {
    navigateForwards() {
      this.viewkey += 1
      this.step = 1
    },
    navigateBackwards() {
      this.viewkey += 1
      this.step = 0
    },
  },
  data() {
    return {
      step: 0,
      viewkey: 0,
    }
  },
  setup() {
    const { t$ } = useTranslate(
      "components.push_wizard.install_pwa_wizard.mobile"
    )
    return { t$ }
  },
})
</script>
